import React from 'react';
import { Box, Typography } from '@mui/material';
import VariantRow from './VariantRow';
import { useAutoTranslation } from 'src/hooks/useTranslate';

const VariantList = ({
  variants = [],
  onClinicianInterpretationChange,
  onReviewDiscrepancy,
  reviewerName,
  onSourceTestClick,
  disabled,
  reclassificationEvents = []
}) => {
  const t = useAutoTranslation();

  if (!variants.length) {
    return (
      <Box
        sx={{
          py: 1.5,
          px: 1.5,
          border: '1px dashed',
          borderColor: 'divider',
          borderRadius: '6px',
          backgroundColor: '#fafaf9'
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary'
          }}
        >
          {t('No variants pushed from test results yet.')}
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {variants.map((variant) => (
        <VariantRow
          key={variant.variantId}
          variant={variant}
          onClinicianInterpretationChange={onClinicianInterpretationChange}
          onReviewDiscrepancy={onReviewDiscrepancy}
          reviewerName={reviewerName}
          onSourceTestClick={onSourceTestClick}
          disabled={disabled}
          reclassifications={reclassificationEvents.filter(
            (e) => e && e.variantId === variant.variantId
          )}
        />
      ))}
    </Box>
  );
};

export default VariantList;
